import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconRegistryComponent, IconRegistryComponentAllowedRegistryKey, TableColumnWithIcon } from '@ui/aos-lib';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';
import { notApplicable } from 'src/app/shared/constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconRegistryComponent, TranslateModule],
  template: `
    <div class="aos-icon-column f-center">
      <ui-icon-registry
        class="aos-icon-column__registry-icon"
        [registryKey]="registryKey()"
      />
      <span [class.inactive]="value() === notApplicable">{{ translatedValue() | translate }}</span>
    </div>
  `,
  styles: `
    .aos-icon-column {
      &__registry-icon {
        min-width: 1.375rem;
      }
    }
  `
})
export class IconColumnComponent {
  item = input.required<{ [key: string]: string }>();
  column = input.required<TableColumnWithIcon>();

  public readonly notApplicable = notApplicable;

  protected registryKey = computed(
    () => this.column().icon.getIconName(this.item(), this.column()) as IconRegistryComponentAllowedRegistryKey
  );
  protected value = computed(() => this.item()[this.column().field]);
  protected translatedValue = computed(
    () => translationKeysMap.get(this.value()) || this.item()[this.column().field] || ''
  );
}
